import React, { FC } from 'react';
import cx from 'classnames';
import styles from './Text.module.scss';
import type { TextProps, TextTypeEnum } from './Text.types';
import { tansformMap, typesMap, weightNameMap } from './contants';
import useBuildVariantProps from '../../../modules/theme/useBuildVariantProps';

const componentTypeMap: Record<TextTypeEnum, React.ElementType<any, 'h1' | 'h2' | 'h3' | 'h4' | 'h5' | 'h6' | 'p'>> = {
  Heading1: 'h1',
  Heading2: 'h2',
  Heading3: 'h3',
  Heading4: 'h4',
  Heading5: 'h5',
  Heading6: 'h6',
  BodyLarge: 'p',
  BodyMedium: 'p',
  BodySmall: 'p',
};

/**
 * Text component definition.
 */
const Text = (props: TextProps) => {
  const {
    className,
    type = 'BodyMedium',
    weight = 'Regular',
    noWrap = false,
    whiteSpaceNoWrap = false,
    italic = false,
    decoration = 'None',
    transform = 'None',
    ellipsis = false,
    as,
    children,
  } = props;
  const TextComponent = as || componentTypeMap[type] || componentTypeMap.BodyMedium;

  const variantProps = useBuildVariantProps(
    'text',
    {
      type: typesMap[type] || 'bodymedium',
      weight: weightNameMap[weight] || 'regular',
    }
  );

  return (
    <TextComponent
      className={cx(
        styles.text,
        {
          [styles.nowrap]: noWrap,
          [styles.whiteSpaceNoWrap]: whiteSpaceNoWrap,
          [styles.italic]: italic,
          [styles.underline]: decoration === 'Underline',
          [styles.strikethrough]: decoration === 'Strikethrough',
          [styles.ellipsis]: ellipsis,
        },
        styles[tansformMap[transform]],
        className,
      )}
      {...variantProps}
    >
      {children}
    </TextComponent>
  );
};
export default Text;
